export default __webpack_public_path__ + "static/media/iconAtencion.07589582.png";